var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-layout",
    { attrs: { row: "", "justify-center": "" } },
    [
      _c(
        "v-dialog",
        {
          attrs: { persistent: "", "max-width": "300px" },
          model: {
            value: _vm.dialog,
            callback: function($$v) {
              _vm.dialog = $$v
            },
            expression: "dialog"
          }
        },
        [
          _c(
            "v-card",
            { staticClass: "alert__form-dialog" },
            [
              _c(
                "div",
                { staticClass: "alert__content pt-3" },
                [
                  _c("v-icon", [_vm._v("icon-ic-check")]),
                  _c("h3", [_vm._v("¡Listo!")]),
                  _c("p", [_vm._v(_vm._s(_vm.alertText))])
                ],
                1
              ),
              _c(
                "v-card-actions",
                { staticClass: "collaborators__buttons-container" },
                [
                  _c(
                    "v-btn",
                    {
                      staticClass: "primary-button blue w110",
                      on: {
                        click: function($event) {
                          _vm.closeModal()
                        }
                      }
                    },
                    [_vm._v("OK")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4e05d03a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4e05d03a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/collaborators/alert-modal.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-4e05d03a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/collaborators/alert-modal.vue
// module chunks = 4 6 7 8 9 10 11 12